import type { FormComponent, ValidationRule } from "../../Form/types/types";
import type { EditableListFormComponent } from "./EditableListFormComponent";

export enum ColumnAlignment {
    LEFT = "Left",
    RIGHT = "Right",
    CENTER = "Center",
}

export type ColumnWidth = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24;

export enum EditableListItemRenderAs {
    TEXT = "Text",
    DATE = "Date",
    BOOLEAN = "Boolean",
    VALIDATIONS_VIEW = "ValidationView",
    HIDDEN = "Hidden",
    DEFAULT_VALUE_VIEW = "DefaultValueView",
}

// TODO Add attributes and move urlToFetchOptions, optionDisplayPropName and optionValuePropName inside them.
export type EditableListItemField = {
    name: string;
    component?: FormComponent | EditableListFormComponent;
    validationRules?: ValidationRule[];
    readonly?: boolean;
    translationKeys?: { label: string };
};

export type EditableListColumnConfig = {
    alignment: ColumnAlignment;
    title: string;
    width: ColumnWidth;
    type: EditableListItemRenderAs;
    field?: EditableListItemField;
};
